import {DATETABS_SELECT_TAB, DATETABS_SET_TABS, DATETABS_SET_TYPE} from 'store/actionTypes';
import {DateTabsType} from 'utils/types';
import {DateTabsAction, DateTabsState} from './types';
import {dateTabsTotal, getDateTabs} from './utils';

// TODO: documentation
// BIQ: is this the proper way to initialize state, or should it be in hook?
const initialState: DateTabsState = {
  tabsType: DateTabsType.DAYS,
  tabs: getDateTabs(DateTabsType.DAYS),
  selectedTabIndex: Math.floor(dateTabsTotal[DateTabsType.DAYS] / 2),
};

const dateTabsReducer = (state = initialState, action: DateTabsAction): DateTabsState => {
  switch (action.type) {
    case DATETABS_SET_TYPE:
      return {
        ...state,
        tabsType: action.payload.tabsType,
      };
    case DATETABS_SET_TABS:
      return {
        ...state,
        tabs: action.payload.tabs,
      };
    case DATETABS_SELECT_TAB:
      return {
        ...state,
        selectedTabIndex: action.payload.selectedIndex,
      };
    default:
      return state;
  }
};

export default dateTabsReducer;
